import { jsx as _jsx } from "react/jsx-runtime";
const ProtectedUnauthorizedLabel = () => {
    return _jsx("div", { className: "text-center", children: "This item is protected. Please authorize first." });
};
export default ProtectedUnauthorizedLabel;
